import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'

const MonthlyPratibedan = () => {

    axios.defaults.withCredentials = true;

    const [mReportList, setmReportList] = useState([])

    const fetchMReports = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/monthly-report`)
            if (response.data.status === "Success") {
                setmReportList(response.data.reportDetail)
            }
            else {
                console.error("Unable to get data!", response.data.errorDetail);
            }
        }
        catch (error) {
            console.error("Error fetching reports:", error)
        }
    }

    mReportList.sort((a, b) => {
        // Assuming year is a string, convert it to a number for comparison
        return Number(b.id) - Number(a.id);
    });

    const handleOpenPdf = (data) => {
        const pdfUrl = `${process.env.REACT_APP_IMG_URL}/reports/monthlyreport/${data}`;
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.target = '_blank';
        link.click();
    }

    useEffect(() => {
        fetchMReports();
    }, [])

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='report-body'>
                    <div className='report-header'>
                        <h3>मासिक प्रतिवेदन</h3>
                    </div>
                    <div className='bg-white rounded shadow report-table-body'>
                        <Table responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>S.N.</th>
                                    <th>Title</th>
                                    <th>Month-Year</th>
                                    <th>Detail</th>
                                </tr>
                            </thead>
                            <tbody>
                                {mReportList.length > 0 ? (
                                    mReportList.map((item, idx) => (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{item.Title}</td>
                                            <td>{item.MonthYear}</td>
                                            <td>
                                                <button
                                                    className='show-button'
                                                    onClick={() => handleOpenPdf(item.PdfUrl)}
                                                >
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={4}>No Record Found In Server!</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default MonthlyPratibedan